export default "__VITE_ASSET__55dff82d__"